import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { breakpointBelow, ResponsiveService, SharedDirectiveModule } from 'b2c-ui/core';
import { tap } from 'rxjs/operators';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { CommonModule } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { FooterLogoIcon, FooterAppstoreIcon, FooterFbIcon, FooterInstaIcon, FooterPlaystoreIcon, FooterYoutubeIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-footer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CFooterModule } from 'b2c-ui/footer';`
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from 'ng-zorro-antd/layout';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from 'ng-zorro-antd/grid';
import * as ɵngcc5 from 'b2c-ui-icon';

function B2CFooterComponent_li_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 14);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r0._facebook);
} }
function B2CFooterComponent_li_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 14);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r1._insta);
} }
function B2CFooterComponent_li_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 14);
    ɵngcc0.ɵɵelement(2, "b2c-ui-icon", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r2._youtube);
} }
function B2CFooterComponent_a_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("link", "//" + ctx_r3.appstore);
} }
function B2CFooterComponent_a_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("link", "//" + ctx_r4.playstore);
} }
function B2CFooterComponent_ng_container_22_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CFooterComponent_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CFooterComponent_ng_container_22_ng_container_1_Template, 1, 0, "ng-container", 21);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.copyrightTemplate);
} }
const _c0 = function (a0) { return { "ismobile": a0 }; };
const _c1 = ["*"];
class B2CFooterComponent {
    /**
     * @param {?} responsiveService
     * @param {?} cdRef
     */
    constructor(responsiveService, cdRef) {
        this.responsiveService = responsiveService;
        this.cdRef = cdRef;
        this._isMobile = false;
        /**
         * @ignore
         */
        this.currentDate = Date.now();
        this.responsiveService
            .observeBoolean(breakpointBelow.sm)
            .pipe(tap((/**
         * @param {?} matched
         * @return {?}
         */
        (matched) => {
            this.isMobile = matched;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * Set Facebook Icon Url
     * @param {?} value
     * @return {?}
     */
    set facebook(value) {
        this._facebook = this.completeLink(value);
    }
    /**
     * Set Instagram Icon Url
     * @param {?} value
     * @return {?}
     */
    set insta(value) {
        this._insta = this.completeLink(value);
    }
    /**
     * Set Youtube Icon Url
     * @param {?} value
     * @return {?}
     */
    set youtube(value) {
        this._youtube = this.completeLink(value);
    }
    /**
     * Set Appstore Icon Url
     * @param {?} value
     * @return {?}
     */
    set appstore(value) {
        this._appstore = 'itms-apps://itunes.apple.com/app/apple-store/id' + value + '?mt=8';
    }
    /**
     * @ignore
     * @return {?}
     */
    get appstore() {
        return this._appstore;
    }
    /**
     * Set Footer to Mobile View
     * @param {?} value
     * @return {?}
     */
    set isMobile(value) {
        this._isMobile = this.coerceBoolean(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get isMobile() {
        return this._isMobile;
    }
    /**
     * Set Playstore Icon Url
     * @param {?} value
     * @return {?}
     */
    set playstore(value) {
        this._playstore = 'market://details?id=' + value;
    }
    /**
     * @return {?}
     */
    get playstore() {
        return this._playstore;
    }
    /**
     * @ignore
     * @param {?} value
     * @return {?}
     */
    coerceBoolean(value) {
        return coerceBooleanProperty(value);
    }
    /**
     * @private
     * @param {?} link
     * @return {?}
     */
    completeLink(link) {
        /** @type {?} */
        const regex = new RegExp('(http://)|(https://)', 'gmi');
        return regex.test(link) ? link : `https://${link}`;
    }
}
B2CFooterComponent.ɵfac = function B2CFooterComponent_Factory(t) { return new (t || B2CFooterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
B2CFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CFooterComponent, selectors: [["b2c-footer"]], inputs: { isMobile: "isMobile", facebook: "facebook", insta: "insta", youtube: "youtube", appstore: "appstore", playstore: "playstore", copyrightTemplate: "copyrightTemplate", name: "name" }, ngContentSelectors: _c1, decls: 23, vars: 17, consts: [[1, "p-0", 3, "ngClass"], [1, "b2c-footer"], [1, "container"], ["nz-row", "", "nzType", "flex", "nzJustify", "space-between"], ["nz-col", "", 3, "nzSpan"], [1, "mb-4"], ["name", "footerLogoIcon"], [3, "ngClass"], [1, "b2c-social-media"], [4, "ngIf"], [1, "list-inline"], ["class", "mb-2 d-inline-block", "external", "", 3, "link", 4, "ngIf"], [1, "b2c-footer-content"], [1, "_copyright_", "b2c-copyright", "m-0"], ["external", "", 3, "link"], ["name", "footerFbIcon"], ["name", "footerInstaIcon"], ["name", "footerYoutubeIcon"], ["external", "", 1, "mb-2", "d-inline-block", 3, "link"], ["name", "footerAppstoreIcon"], ["name", "footerPlaystoreIcon"], [4, "ngTemplateOutlet"]], template: function B2CFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nz-footer", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelement(6, "b2c-ui-icon", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "ul", 8);
        ɵngcc0.ɵɵtemplate(9, B2CFooterComponent_li_9_Template, 3, 1, "li", 9);
        ɵngcc0.ɵɵtemplate(10, B2CFooterComponent_li_10_Template, 3, 1, "li", 9);
        ɵngcc0.ɵɵtemplate(11, B2CFooterComponent_li_11_Template, 3, 1, "li", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "ul", 10);
        ɵngcc0.ɵɵelementStart(13, "li");
        ɵngcc0.ɵɵtemplate(14, B2CFooterComponent_a_14_Template, 2, 1, "a", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "li");
        ɵngcc0.ɵɵtemplate(16, B2CFooterComponent_a_16_Template, 2, 1, "a", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 4);
        ɵngcc0.ɵɵelementStart(18, "div", 12);
        ɵngcc0.ɵɵelementStart(19, "div", 7);
        ɵngcc0.ɵɵprojection(20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "p", 13);
        ɵngcc0.ɵɵtemplate(22, B2CFooterComponent_ng_container_22_Template, 2, 1, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c0, ctx.isMobile));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("nzSpan", ctx.isMobile ? 24 : 3);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c0, ctx.isMobile));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx._facebook);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._insta);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._youtube);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.coerceBoolean(ctx.appstore));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.coerceBoolean(ctx.playstore));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nzSpan", ctx.isMobile ? 24 : 21);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c0, ctx.isMobile));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.copyrightTemplate);
    } }, directives: [ɵngcc2.NzFooterComponent, ɵngcc3.NgClass, ɵngcc4.NzRowDirective, ɵngcc4.NzColDirective, ɵngcc5.B2CUiIconComponent, ɵngcc3.NgIf, ɵngcc1.ExternalLinkDirective, ɵngcc3.NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CFooterComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ChangeDetectorRef }
];
B2CFooterComponent.propDecorators = {
    copyrightTemplate: [{ type: Input }],
    facebook: [{ type: Input }],
    insta: [{ type: Input }],
    youtube: [{ type: Input }],
    appstore: [{ type: Input }],
    isMobile: [{ type: Input }],
    playstore: [{ type: Input }],
    name: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CFooterComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-footer',
                template: "<nz-footer class=\"p-0\" [ngClass]=\"{'ismobile': isMobile}\">\r\n  <div class=\"b2c-footer\">\r\n    <div class=\"container\">\r\n      <div nz-row nzType=\"flex\" nzJustify=\"space-between\">\r\n        <div nz-col [nzSpan]=\"isMobile ? 24 : 3\">\r\n          <div class=\"mb-4\">\r\n            <b2c-ui-icon name=\"footerLogoIcon\"></b2c-ui-icon>\r\n          </div>\r\n          <div [ngClass]=\"{'ismobile': isMobile}\">\r\n            <ul class=\"b2c-social-media\">\r\n              <li *ngIf=\"_facebook\">\r\n                <a external [link]=\"_facebook\">\r\n                  <b2c-ui-icon name=\"footerFbIcon\"></b2c-ui-icon>\r\n                </a>\r\n              </li>\r\n              <li *ngIf=\"_insta\">\r\n                <a external [link]=\"_insta\">\r\n                  <b2c-ui-icon name=\"footerInstaIcon\"></b2c-ui-icon>\r\n                </a>\r\n              </li>\r\n              <li *ngIf=\"_youtube\">\r\n                <a external [link]=\"_youtube\">\r\n                  <b2c-ui-icon name=\"footerYoutubeIcon\"></b2c-ui-icon>\r\n                </a>\r\n              </li>\r\n            </ul>\r\n            <ul class=\"list-inline\">\r\n              <li>\r\n                <a class=\"mb-2 d-inline-block\" external [link]=\"'//' + appstore\"  *ngIf=\"coerceBoolean(appstore)\">\r\n                  <b2c-ui-icon name=\"footerAppstoreIcon\"></b2c-ui-icon>\r\n                </a>\r\n              </li>\r\n              <li>\r\n                <a class=\"mb-2 d-inline-block\" external [link]=\"'//' + playstore\" *ngIf=\"coerceBoolean(playstore)\">\r\n                  <b2c-ui-icon name=\"footerPlaystoreIcon\"></b2c-ui-icon>\r\n                </a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <div nz-col [nzSpan]=\"isMobile ? 24 : 21\">\r\n          <div class=\"b2c-footer-content\">\r\n            <div [ngClass]=\"{'ismobile': isMobile}\">\r\n              <ng-content></ng-content>\r\n            </div>\r\n          </div>\r\n          <p class=\"_copyright_ b2c-copyright m-0\">\r\n            <ng-container *ngIf=\"copyrightTemplate\">\r\n              <ng-container *ngTemplateOutlet=\"copyrightTemplate\"></ng-container>\r\n            </ng-container>\r\n          </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</nz-footer>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { isMobile: [{
            type: Input
        }], facebook: [{
            type: Input
        }], insta: [{
            type: Input
        }], youtube: [{
            type: Input
        }], appstore: [{
            type: Input
        }], playstore: [{
            type: Input
        }], copyrightTemplate: [{
            type: Input
        }], name: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CFooterComponent.prototype._appstore;
    /**
     * @type {?}
     * @private
     */
    B2CFooterComponent.prototype._playstore;
    /**
     * @type {?}
     * @private
     */
    B2CFooterComponent.prototype._isMobile;
    /** @type {?} */
    B2CFooterComponent.prototype._facebook;
    /** @type {?} */
    B2CFooterComponent.prototype._insta;
    /** @type {?} */
    B2CFooterComponent.prototype._youtube;
    /**
     * Set copyright template
     * @type {?}
     */
    B2CFooterComponent.prototype.copyrightTemplate;
    /**
     * Set Company Name Url
     * @type {?}
     */
    B2CFooterComponent.prototype.name;
    /**
     * @ignore
     * @type {?}
     */
    B2CFooterComponent.prototype.currentDate;
    /**
     * @type {?}
     * @private
     */
    B2CFooterComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CFooterComponent.prototype.cdRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-footer.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [
    FooterLogoIcon,
    FooterAppstoreIcon,
    FooterFbIcon,
    FooterInstaIcon,
    FooterPlaystoreIcon,
    FooterYoutubeIcon
];
class B2CFooterModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CFooterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CFooterModule });
B2CFooterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CFooterModule_Factory(t) { return new (t || B2CFooterModule)(ɵngcc0.ɵɵinject(ɵngcc5.B2CUiIconService)); }, imports: [[CommonModule, NzLayoutModule, B2cUiIconModule, NzGridModule, SharedDirectiveModule]] });
/** @nocollapse */
B2CFooterModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CFooterModule, { declarations: function () { return [B2CFooterComponent]; }, imports: function () { return [CommonModule, NzLayoutModule, B2cUiIconModule, NzGridModule, SharedDirectiveModule]; }, exports: function () { return [B2CFooterComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CFooterModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CFooterComponent],
                exports: [B2CFooterComponent],
                imports: [CommonModule, NzLayoutModule, B2cUiIconModule, NzGridModule, SharedDirectiveModule]
            }]
    }], function () { return [{ type: ɵngcc5.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CFooterModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-footer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CFooterComponent, B2CFooterModule };


//# sourceMappingURL=b2c-ui-footer.js.map